import React from 'react';

import DotLoader from 'react-spinners/DotLoader';

const LoaderPage = () => {

  return (
    <section className='page-container'>
      <div className='loader-stage'>
        <div className='modal-hover-center'>
            <DotLoader
                color={'#6100FF'}
                loading={true}
                size={150}
                aria-label="Loading Spinner"
                data-testid="loader"/>
        </div>
      </div>
    </section>
  );
};
  
export default LoaderPage;